
import React, {useState, useEffect, useContext} from "react";
import { Box, Button, Paper, Typography, Fade } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import DownloadDocxButton from "../components/DownloadDocx";
import Cookies from "js-cookie";
import { ArrowBackIosNew } from "@mui/icons-material";
import { use } from "react";



export const DocumentViewer = (props)=>{

      const user = JSON.parse(Cookies.get('user'));
           const userId = user.id;
        
        const location = useLocation();
        const state = location.state;
        const navigate = useNavigate();
        const [data, setData] = useState(null)
        const [editorContent, setEditorContent] = useState(state.data.content);
        const [job, setJob] = useState(state.data.documentName)
        const [documentHtml, setDocumentHtml] = useState('')
        const handleBack = ()=>{
            const check = window.confirm('If you choose to go back your questionnaire will not be saved. Are you sure you would like to do this?')
            if(check){
              navigate(-1)
            }
            }
            useEffect(() => {
                const generateHtml = () => {
                  const htmlString = editorContent
                    .map(
                      (content) => `
                        <div style="margin-top: 16px; padding: 16px; border: 1px solid #ddd;">
                          <p style="font-weight: bold;">Name: <span>${content.name}</span></p>
                          <p style="font-weight: bold;">Ranking: <span>${content.ranking}</span></p>
                          <div>${content.explanation}</div>
                        </div>
                        <divider/>
                      `
                    )
                    .join(''); // Combine all generated HTML into one string
                  return htmlString;
                };
            
                setDocumentHtml(generateHtml());
              }, [editorContent]); // Runs whenever editorContent changes
            

    return (
    <div style={{ overflowY: "auto", maxHeight: "100vh", paddingBottom: 100, marginTop: 80 }}>

        <Box sx={{marginBottom:'10px'}}>
        <Button variant="contained" onClick={handleBack}><ArrowBackIosNew/> <b>BACK</b></Button>            
        <DownloadDocxButton htmlContent={documentHtml} docName={job} />
       
        </Box>
        <Paper sx={{ p: 2, marginTop: 2 }}>
<Typography variant="h6"><b>Resume Comparison Results</b></Typography>
{editorContent.length > 0 ? (
editorContent.map((content, index) => (
  <Box key={index} sx={{ marginTop: 2, padding: 2, border: '1px solid #ddd' }}>
    <Typography variant="subtitle1"><b>Name:</b> {content.name}</Typography>
    <Typography variant="subtitle2"><b>Ranking:</b> {content.ranking}</Typography>
    <Typography variant="body1" dangerouslySetInnerHTML={{ __html: content.explanation }} />
  </Box>
))
) : (
<Typography>No results to display.</Typography>
)}
</Paper>
</div>
)
}

